<template>
  <v-dialog v-model="subgroupDialog" width="500" @click:outside="closeDialog">
    <v-card v-if="subgroup">
      <v-card-title class="headline">{{ $t("common.delete") }} {{ subgroup.name }}</v-card-title>

      <v-card-text>
        {{ $t("subgroup.DeleteSubgroup.questionDelete") }}
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-checkbox
          v-model="deleteChat"
          :label="this.$t('subgroup.DeleteSubgroup.deleteChat')"
          required
        ></v-checkbox>
        <div class="flex-grow-1"></div>
        <v-btn color="primary" @click="closeDialog" text>{{ $t("common.cancel") }}</v-btn>
        <v-btn color="primary" v-if="!dialogLoading" @click="deleteSubgroup">{{
          $t("common.ok")
        }}</v-btn>
        <v-progress-circular
          v-if="dialogLoading"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import firestore from "@/firebase/firestore";

export default {
  name: "DeleteSubgroup",
  props: ["subgroupkey"],
  data() {
    return {
      subgroupDialog: false,
      dialogLoading: false,
      deleteChat: false,
    };
  },
  computed: {
    subgroup() {
      if (!this.$props.subgroupkey) return null;
      return this.$store.state.trip.subgroups[this.$props.subgroupkey];
    },
  },
  watch: {
    subgroupkey(newVal) {
      console.log("subgroupKey changed for delete");
      if (newVal) {
        this.subgroupDialog = true;
      }
    },
  },
  methods: {
    deleteSubgroup() {
      this.dialogLoading = true;

      const tripId = this.$store.getters.currentTripId;

      if (this.deleteChat === true) {
        firestore.deleteDocument(tripId, "chats", this.$props.subgroup.chat);
      }
      firestore.deleteDocument(tripId, "subgroups", this.$props.subgroupkey);

      this.subgroupDialog = false;
      this.dialogLoading = false;
    },
    closeDialog() {
      this.subgroupDialog = false;
      this.$emit("closed");
    },
  },
};
</script>
